/* eslint-disable */
/* eslint-disable prefer-const */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable prefer-const */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useState,
  useEffect,
  useContext,
  useImperativeHandle,
} from 'react';

import { ReactComponent as Uploading } from '../../../assets/images/cloud-uploading.svg';
import BlueCard from './blueCard';
import WhiteCard from './whiteCard';
import { Usercontext } from './searchResult';
import { getCompetitors, GetEmployeeID, GetRole } from '../../../api/user';
import CurrencyInput from 'react-currency-input-field';
import { AgreementContext } from '../../../context/AgreementContext';
import { addedItemStyles } from '../../../JSstyles/addedItemStyles';
// import {agreementStyle} from './Test';
import SecondFactor from '../TwoFactorPopup/TwoFactorPopup';
// import Erroricon from '../../../assets/images/erroricon.png';
import { ReactComponent as Erroricon } from '../../../assets/images/error-icon.svg';

import {
  RACCheckBox,
  RACTextbox,
  RACSelect,
  RACModalCard,
  RACButton,
  Grid,
  Card,
  CardContent,
  Typography,
  RACChip,
  CircularProgress,
} from '@rentacenter/racstrap';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveItemRestriction } from '../../../utils/itemRestrictionUtils';
import { extractInventoryNumber, extractRmsItemNumbers, mapRateTermFromItemPricing } from '../../../utils/rewardUtils';

const AddedItem = (props: any) => {

  const { language } = useContext(AgreementContext)
  const { i18n, t } = useTranslation('rental');

  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const classes = props.throwStyle;
  const addedItemClassName = addedItemStyles();
  // const classes = useClasses();
  const shareData: any = useContext(Usercontext);
  const {
    competitorDataContext,
    setproofFileName,
    proofFileName,
    isCompCheck,
    setisCompCheck,
    agreementCreateStatus,
    initialAgrData,
    containCompetitor,
    setselectedCompetitor,
    selectedCompetitor,
    isInReinstateMode,
    isSacDaysCompleted,
    coworkerCheck,
    setcompetitorProofData,
    checkedState,
    setcheckedState,
    // setinitialAgrData,
    initialAgrTerm,
    termOverrideLimitBase,
    isExchangeAgreement,
    addedItem,
    itemSearchDuplicate,
    allItemsAllowed,
    setAllItemsAllowed,
    setRmsItemNumbers,
    setPromocodeInventoryNumber,
    setAgreementRateTerm,
    maximumAllowedTerm
  } = useContext(AgreementContext);
  const { priceOverrideLimitDetails, featureFlagDetails, termOverrideLimitDetails, } = useContext(FeatureFlagContext)
  const compeFileNameObj = {
    fileNameCompetitor: '',
  };
  const [competitorData, setcompetitorData] = competitorDataContext;
  // const [compeFileName, setcompeFileName] = useState('');
  const [compeFileName, setcompeFileName] = useState(compeFileNameObj);
  const [SecondFactorEnabled, setSecondFactorEnabled] = useState(false);
  const SLAObj = {
    TwoFactorCancelClick: false,
    TwoFactorCompleted: false,
  };
  const needSLAObj = {
    needSLAController: false,
  };
  const [percentCalculation, setpercentCalculation] = useState(0);
  const [SLAController, setSLAController] = useState(SLAObj);
  const [needSLA, setneedSLA] = React.useState(needSLAObj);
  const [thresHoldExceptionMessage, setthresHoldExceptionMessage] =
    useState('');
  const [slaErrorMessage, setslaErrorMessage] = useState('')
  const [initialAgreementRate, setinitialAgreementRate] = useState<any>();
  const [initialAgreementTerm, setIntialAgreementTerm] = useState<any>();
  // UI validates later term edits against the backend-adjusted term shown after a rate override.
  const effectiveTermOverrideLimitBase = termOverrideLimitBase ?? initialAgrTerm;
  const [agrRate, setagrRate]: any = useState('0.00');
  const [agrTerm, setagrTerm]: any = useState('0.00');
  const [openRateAlertModal, setopenRateAlertModal] = useState(false);
  const [openTermAlertModal, setopenTermAlertModal] = useState(false);
  const [invalidTermPopup, setInvalidTermPopup] = useState(false)
  const termLimitForPopupRef = React.useRef<number | undefined>(undefined);
  // shown only while a term override is waiting for a background legal/price call
  // (sequential-path items — addAllItem/tagPackageInvCaller) to settle before validating.
  const [isAwaitingLegalPrice, setIsAwaitingLegalPrice] = useState(false)

  const [agrTotal, setAgrTotal] = useState('0.00');
  const [cashPrice, setCashPrice] = useState('0.00');
  const [epoAmount, setepoAmount] = useState('0.00');
  const [slaOverrideInvalid, setslaOverrideInvalid] = useState('');
  const [conditionLoader, setconditionLoader] = useState<boolean>(true);

  const [fullCompeFileName, setfullCompeFileName] = useState<any>('');
  const [competitorAry, setcompetitorAry] = useState<any>();
  const [competitorSelect, setcompetitorSelect] = useState<any>('');
  const [enableZeroValidate, setenableZeroValidate] = React.useState(false);
  const [invalidTerm, setinvalidTerm] = React.useState(false);
  // const [controlCurrencyInput, setcontrolCurrencyInput] = React.useState(false);
  const [SLAMinRole, setSLAMinRole] = useState('');
  const ModuleName = 'Edit AgmtRt W/O Competitor';
  const [CurrentRole, setCurrentRole] = useState('');

  const [controlCompetitor, setControlCompetitor] = useState(true);
  const [roleFromSLA, setroleFromSLA] = useState('');
  //const [pricedata, setpricedata] = React.useState([]);
  const [proof, setproof] = useState('');
  const [correctProof, setcorrectProof] = useState(false);
  const [wrongProof, setwrongProof] = useState(false);
  const [bigFile, setbigFile] = useState(false);
  // const [throwPackageValue, setthrowPackageValue] = useState<any>();
  // const [classes, setclasses] = useState<any>();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);


  const configDataObj = priceOverrideLimitDetails;
  const configTermDataObj = termOverrideLimitDetails;

  const configData = configDataObj;
  const termValidationConfigData = configTermDataObj;

  const currentStoreNumber = window.sessionStorage.getItem('storeNumber') || '';

  useEffect(() => {
    if (proofFileName !== undefined) {
      setproof('');
      setcompeFileName({ ...compeFileName, fileNameCompetitor: proofFileName });
      console.log('proofFileName', proofFileName);
      setcorrectProof(true);
    }

    if (selectedCompetitor !== undefined) {
      setcompetitorSelect(selectedCompetitor);
    } else {
      setcompetitorSelect('');
      setcorrectProof(false);
    }
    console.log('isCompCheck checing log', isCompCheck);
    setcheckedState(isCompCheck);
    props.setCompetitorValue(isCompCheck);
    setControlCompetitor(!isCompCheck);
    console.log('agreementCreateStatus', agreementCreateStatus);
    // setclasses(props.throwStyle)

    // if (props.throwcollectCompetitor !== undefined) {
    //   setcompetitorAry(props.throwcollectCompetitor);
    // }
    console.log('containCompetitor checking', containCompetitor);

    if (containCompetitor !== undefined) {
      setcompetitorAry(containCompetitor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('CustomerInfoContextmm', coworkerCheck);
  }, []);

  useEffect(() => {
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRole = GetMenuDetailsResponse.coworkerProfile.role;
          console.log('currentRole', currentRole);
          setCurrentRole(currentRole);
        }
      }
    };
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setCurrentRole(containerData.GetRole());
    } else {
      GettingRole();
    }

  }, []);

  useEffect(() => {
    setcheckedState(isCompCheck);
    setControlCompetitor(!isCompCheck);
    // setcorrectProof(false);
    setcompetitorSelect('');

    if (selectedCompetitor !== undefined) {
      setcompetitorSelect(selectedCompetitor);
    } else {
      setcompetitorSelect('');
      setcorrectProof(false);
    }
  }, [isCompCheck, selectedCompetitor]);

  const { customerVerifyLevel, customerApprovalDetails } = props;
  const EnableCustomerLevelItemRestriction = featureFlagDetails?.EnableCustomerLevelItemRestriction;
  const productRestrictDetails = props?.customerDetails?.value?.customerLevelItemRestriction;
  const productExclusions = props?.productExclusions;
  const ItemRestrictionCustomerLevels = JSON.parse(featureFlagDetails?.ItemRestrictionCustomerLevels || "[]");
  const ItemRestrictionLegacyFlow = featureFlagDetails?.ItemRestrictionLegacyFlow;

  console.log("Feature flag settings:", {
    EnableCustomerLevelItemRestriction,
    ItemRestrictionCustomerLevels
  });

  console.log("Customer verification level:", customerVerifyLevel);
  console.log("Product restriction details:", productRestrictDetails);

  const checkAllItemsAllowed = () => {
    console.log("Checking items in addedItem:", addedItem);
    console.log("Available search items:", itemSearchDuplicate);

    if (!addedItem || !Array.isArray(addedItem.itemPricing) || addedItem.itemPricing.length === 0) {
      console.log("No items to check or itemPricing is empty - defaulting to allowed");
      return true;
    }

    if (!itemSearchDuplicate || Object.keys(itemSearchDuplicate).length === 0) {
      console.log("No search items to compare with - defaulting to allowed");
      return true;
    }

    console.log(`Checking ${addedItem.itemPricing.length} added items for restrictions`);

    const searchItemsArray:any = Object.values(itemSearchDuplicate);

    for (const addedItemData of addedItem.itemPricing) {
      console.log("Processing added item:", addedItemData);

      const matchingItem = searchItemsArray.find(searchItem =>
        searchItem.inventoryNumber === addedItemData.inventoryNumber
      );

      if (!matchingItem) {
        console.log(`Warning: No matching item found in search results for inventory ${addedItemData.inventoryNumber}`);
        continue;
      }

      console.log("Found matching item with complete data:", matchingItem);

      const isAllowed = resolveItemRestriction({
        ItemRestrictionLegacyFlow,
        item: matchingItem,
        EnableCustomerLevelItemRestriction,
        productExclusions,
        customerLevel: customerVerifyLevel,
        customerApprovalDetails,
        restrictionConfig: productRestrictDetails,
        ItemRestrictionCustomerLevels
      });

      console.log(`Item ${matchingItem.inventoryNumber} allowed:`, isAllowed);

      if (!isAllowed) {
        console.log("Found restricted item - returning false for all items check");
        return false;
      }
    }

    console.log("All items passed restriction check");
    return true;
  };

  const getEligiblePromotions = () => {
    const extractedRMSNumbers = extractRmsItemNumbers(addedItem)
    const extractedInventoryNumber = extractInventoryNumber(addedItem)
    const extractedAgreementRateTerm = mapRateTermFromItemPricing(addedItem)
    console.log("extractedRMSNumbers: ",extractedRMSNumbers);
    console.log("extractedInventoryNumber: ",extractedInventoryNumber);
    setRmsItemNumbers(extractedRMSNumbers)
    setPromocodeInventoryNumber(extractedInventoryNumber)
    setAgreementRateTerm(extractedAgreementRateTerm)
  }

  useEffect(() => {
    console.log("Dependencies changed, rechecking item restrictions");
    const isAllowed = checkAllItemsAllowed();
    console.log("Final restriction result:", isAllowed);
    setAllItemsAllowed(!isAllowed);
    getEligiblePromotions();
  }, [addedItem, itemSearchDuplicate]);

  useEffect(() => {
    console.log("allItemsAllowed state updated:", allItemsAllowed);
  }, [allItemsAllowed]);


  const competitorArrayFunction = () => {
    if (competitorAry !== undefined) {
      console.log('competitorAry data', competitorAry);

      return competitorAry.map((entry) => {
        // if (index === 0) {
        //   return { label: 'Select', value: null };
        // } else {
        return { label: (language == 'es-US' || language == 'es-MX') ? entry.descSpanish : entry.description, value: entry.referenceCode };
        // }
      });
    } else {
      return [{ label: t('Select'), value: '0' }];
    }
  };

  // const buildDropdownOptions = (dropDownList: any[]) => {
  //   return dropDownList.map((value, index) => {
  //     return (
  //       <option key={index} value={value.referenceCode}>
  //         {value.description}
  //       </option>
  //     );
  //   });
  // };

  useEffect(() => {
    console.log('before if condition', props.priceexceptionMessage);
    // setthrowPackageValue(props.throwPackage);
    if (
      props.priceexceptionMessage !== null &&
      props.priceexceptionMessage !== undefined
    ) {
      console.log(
        'inside props data of price exception',
        props.priceexceptionMessage
      );
      handleExceptionRevert();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.priceexceptionMessage]);
  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(() => {
    //debugger
    if (shareData !== undefined) {
      console.log('Added Item Shared Data', shareData);

      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(isExchangeAgreement ? shareData?.agreementPricing?.exchangeAgreementTerm : shareData.agreementPricing.agreementTerm);
      setAgrTotal(isExchangeAgreement ? parseFloat(shareData?.agreementPricing?.exchangeAgreementTotal).toFixed(2) : shareData.agreementPricing.agreementTotal);
      setCashPrice(isExchangeAgreement ? shareData?.agreementPricing?.exchangeCashPrice : shareData.agreementPricing.cashPrice);
      if (addedItem.agreementPricing.epoAmount && featureFlagDetails.MXStoreIdentifier == "1") {
        setepoAmount(addedItem.agreementPricing.epoAmount)
      }
      else if (shareData.agreementPricing?.epoAmount) {
        setepoAmount(shareData.agreementPricing.epoAmount);
      }
      if (initialAgrData === undefined) {
        // setinitialAgrData(shareData.agreementPricing.agreementRate);
        setinitialAgreementRate(shareData?.agreementPricing?.agreementRate);
        setIntialAgreementTerm(isExchangeAgreement ? shareData?.agreementPricing?.exchangeAgreementTerm ? shareData?.agreementPricing?.exchangeAgreementTerm : shareData?.agreementPricing?.agreementTerm : shareData?.agreementPricing?.agreementTerm)

      } else {
        setinitialAgreementRate(initialAgrData);
        setIntialAgreementTerm(initialAgrTerm);
      }
      if (initialAgrData !== undefined) {
        setinitialAgreementRate(initialAgrData);
        setIntialAgreementTerm(initialAgrTerm);

      }
    } else {
      setagrRate('');
      setagrTerm('');
      setAgrTotal('');
      setCashPrice('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proof, shareData]); // this method is used to validate the proof //PS-8

  const agrRatechange = (AgrRate: any) => {
    setagrRate(AgrRate);
  };
  // this method will store the new agr Rate value

  const agrTermchange = (AgrTerm: any) => {
    setagrTerm(AgrTerm);
  }; // this method will store the new agr Term value

  const handleExceptionRevert = () => {
    if (shareData !== undefined) {
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(shareData.agreementPricing.agreementTerm);
    }
    //setcheckedState(false);
  };

  const setDefault = () => {
    console.log('gbfvdcsdkdshbvsdb reach std');
    if (shareData !== undefined) {
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(isExchangeAgreement ? shareData?.agreementPricing?.exchangeAgreementTerm : shareData.agreementPricing.agreementTerm);
    }
    props.setCompetitorValue(false);
    setcheckedState(false);
    // setcontrolCurrencyInput(false);
    setisCompCheck(false);
    setcompetitorSelect('');
    setselectedCompetitor(undefined);
    props.setCompetitorDropValue('0');
    props.triggerSetToDefault();
    setControlCompetitor(true);
    setcorrectProof(false);
  }; // this method will store the default  agr Term and Rate value //PS-7
  const closeInvalidTermAndRate = () => {
    // setDefault();
    if (shareData !== undefined) {
      setagrRate(shareData.agreementPricing.agreementRate);
      setagrTerm(shareData.agreementPricing.agreementTerm);
    }

    setinvalidTerm(false);
    setenableZeroValidate(false);
    termLimitForPopupRef.current = undefined;
  };

  // const checkAgrRateChange = (e: any) => {
  //   if (e.key == "Enter") {
  //     (document.getElementById("AgrRate") as HTMLInputElement).blur();
  //     if (parseInt(agrRate) <= 0) {
  //       setenableZeroValidate(true);
  //     } else {
  //       props.setreceiveAgreementRate(agrRate);
  //     }
  //   }
  // };

  // const checkAgrTermChange = (e: any) => {
  //   if (e.key == "Enter") {
  //     if (parseInt(agrTerm) < 1) {
  //       setinvalidTerm(true);
  //     } else {
  //       props.setreceiveAgreementTerm(agrTerm);
  //     }
  //   }
  // };

  const truncString = (str: any, max: number, add: any) => {
    add = add || '...';
    return typeof str === 'string' && str.length > max
      ? str.substring(0, max) + add
      : str;
  };

  // RP-668: async to support awaiting a pending background legal/price call before term validation.
  const blurFuction = async (functionController: any): Promise<any> => {
    //debugger
    console.log('checking agrrate', agrRate);
    console.log('initialAgreementRate', initialAgreementRate);
    console.log(
      'checking shareData.agreementPricing.agreementRate',
      shareData.agreementPricing.agreementRate
    );

    if (
      functionController == 'RateChange' &&
      Number(agrRate) !== Number(shareData.agreementPricing.agreementRate)
    ) {
      
      // Validate rate is not less than 1
      if (Number(agrRate) < 1) {
        setenableZeroValidate(true);
        return;
      }

      if (featureFlagDetails?.MXStoreIdentifier == '1' && Number(agrRate) > Number(initialAgreementRate)) {
        setopenRateAlertModal(true);
        setslaErrorMessage(`${t("Rate is invalid")}`);
        return;
      }

      const isRateDecrease = Number(agrRate) <= Number(initialAgreementRate);
      const configLimitKey = isRateDecrease ? 'min' : 'max';

      // Get both min and max limits for full range calculation
      const values = Object.values(configDataObj);
      const minValues = values
        .filter((value: any) => value && typeof value === 'object' && 'min' in value)
        .map((value: any) => Number(value.min))
        .filter((v: number) => !isNaN(v));
      const maxValues = values
        .filter((value: any) => value && typeof value === 'object' && 'max' in value)
        .map((value: any) => Number(value.max))
        .filter((v: number) => !isNaN(v));

      const numericValues = values
        .filter((value: any) => value && typeof value === 'object' && configLimitKey in value)
        .map((value: any) => Number(value[configLimitKey]))
        .filter((v: number) => !isNaN(v));

      if (numericValues.length === 0) {
        // No valid config for this direction — allow the change through
        Number(agrRate) < 1
          ? setenableZeroValidate(true)
          : props.setreceiveAgreementRate(agrRate);
        return;
      }

      const maxPercentageEdit = Math.max(...numericValues);
      const maxMinPercentageEdit = minValues.length > 0 ? Math.max(...minValues) : maxPercentageEdit;
      const maxMaxPercentageEdit = maxValues.length > 0 ? Math.max(...maxValues) : maxPercentageEdit;
      const maxAllowablbeLimit = (Number(initialAgreementRate) * Number(maxPercentageEdit)) / 100

      let percentCalculationInBlur: any
      percentCalculationInBlur = Math.abs(
        ((initialAgreementRate - agrRate) * 100) / initialAgreementRate
      );
      percentCalculationInBlur = (Math.floor(Number(percentCalculationInBlur) * 100) / 100).toFixed(2)

      if (!checkedState) {
        console.log('success reach of if in rate chage');

        let minRole = '';
        let enteredIf = false;
        let output;

        const Roles = [
          'FSC-CAR',
          'CAR',
          'RPMT',
          'FSC-AM',
          'AM',
          'FSC-LAM',
          'LAM',
          'FSC-SMT',
          'SMT',
          'FSC-SM',
          'SM',
          'FSC-SSM',
          'SSM',
          'CAM',
          'FSC-DMT',
          'DMT',
          'FSC-DM',
          'DM',
          'FSC-RDT',
          'RDT',
          'FSC-RD',
          'RD'
        ];
        if (Number(maxPercentageEdit) < Number(percentCalculationInBlur)) {
          const maxMinLimit = (Number(initialAgreementRate) * Number(maxMinPercentageEdit)) / 100;
          const maxMaxLimit = (Number(initialAgreementRate) * Number(maxMaxPercentageEdit)) / 100;
          const lowerBound = Number(Number(initialAgreementRate) - maxMinLimit).toFixed(2);
          const upperBound = Number(Number(initialAgreementRate) + maxMaxLimit).toFixed(2);
          if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t("Rate is invalid. Allowable Rate Values are $")} ${lowerBound} ${t("to")} $${upperBound}`)
          }
          else {
            setopenRateAlertModal(true)
            setslaErrorMessage(`${t("Override is invalid. SLA user can override from $")} ${lowerBound} ${t("to")} $${upperBound}`)
          }
        }
        else {
          for (const item in configDataObj) {
            const roleLimitValue = configData[item]?.[configLimitKey];
            if (roleLimitValue == undefined) continue;
            console.log('item in configDataObj', roleLimitValue);
            if (
              roleLimitValue == Number(percentCalculationInBlur).toFixed(2) &&
              Number(percentCalculationInBlur) !== 0
            ) {
              console.log('correct item in configDataObj', roleLimitValue);
              minRole = item;
              output = item;
              setSLAMinRole(item);

              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            } else if (roleLimitValue > Number(percentCalculationInBlur)) {
              console.log('correct item in configDataObj', roleLimitValue);
              minRole = item;
              output = item
              setSLAMinRole(item);

              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            }
          }

          console.log('logged roles', CurrentRole);

          // Build grouped data for BOTH min and max to get current role's limits
          const groupedDataMin: { [key: string]: string[] } = {};
          const groupedDataMax: { [key: string]: string[] } = {};

          for (const [key, value] of Object.entries(configData)) {
            const minLimitValue = (value as any)?.['min'];
            const maxLimitValue = (value as any)?.['max'];

            if (minLimitValue != undefined) {
              const stringValue = String(minLimitValue);
              if (!groupedDataMin[stringValue]) {
                groupedDataMin[stringValue] = [key];
              } else {
                groupedDataMin[stringValue].push(key);
              }
            }

            if (maxLimitValue != undefined) {
              const stringValue = String(maxLimitValue);
              if (!groupedDataMax[stringValue]) {
                groupedDataMax[stringValue] = [key];
              } else {
                groupedDataMax[stringValue].push(key);
              }
            }
          }

          console.log("groupedDataMin", groupedDataMin)
          console.log("groupedDataMax", groupedDataMax)

          let currentRoleMinValue: number = 0;
          let currentRoleMaxValue: number = 0;

          for (const key of Object.keys(groupedDataMin)) {
            if (groupedDataMin[key].includes(CurrentRole)) {
              currentRoleMinValue = parseInt(key) || 0;
              break;
            }
          }

          for (const key of Object.keys(groupedDataMax)) {
            if (groupedDataMax[key].includes(CurrentRole)) {
              currentRoleMaxValue = parseInt(key) || 0;
              break;
            }
          }

          console.log("currentRoleMinValue", currentRoleMinValue)
          console.log("currentRoleMaxValue", currentRoleMaxValue)

          // Safety check: if role values are not found, use 0 to avoid NaN
          if (currentRoleMinValue === 0 && currentRoleMaxValue === 0) {
            console.warn("Role limits not found for:", CurrentRole);
          }

          let allowedMinRate = Number(initialAgreementRate) - (Number(initialAgreementRate) * (currentRoleMinValue / 100));
          let allowedMaxRate = Number(initialAgreementRate) + (Number(initialAgreementRate) * (currentRoleMaxValue / 100));

          console.log("allowedMinRate", allowedMinRate)
          console.log("allowedMaxRate", allowedMaxRate)
          console.log("initialAgreementRate", initialAgreementRate)

          setthresHoldExceptionMessage(
            isRateDecrease
              ? `${t("Coworker can only change rate upto $")} ${Number(
                allowedMinRate.toString()
              ).toFixed(2)} ${t("second level approval is required for this change.")}`
              : `${t("Coworker can only change rate upto $")} ${Number(
                allowedMaxRate.toString()
              ).toFixed(2)} ${t("second level approval is required for this change.")}`
          );


          if (enteredIf === false) {
            console.log('entered if pricing call', enteredIf);

            Number(agrRate) < 1
              ? setenableZeroValidate(true)
              : props.setreceiveAgreementRate(agrRate);
          }
        }

      } else {

        Number(agrRate) < 1
          ? setenableZeroValidate(true)
          : props.setreceiveAgreementRate(agrRate);
      }

    } else if (
      functionController == 'TermChange' &&
      agrTerm !== shareData?.agreementPricing?.agreementTerm
    ) {

      // Validate term is not less than 1
      if (Number(agrTerm) < 1) {
        setinvalidTerm(true);
        return;
      }

      // sequential-path items (addAllItem/tagPackageInvCaller) fire legal/price
      // silently in the background with no loader. If the user overrides the term before that
      // background call has settled, show the invalidTermPopup with a spinner inside it,
      // wait for the legal call to resolve, then validate with the fresh ceiling value.
      let awaitedMaximumAllowedTerm: number | undefined = maximumAllowedTerm;
      if (props.throwHasPendingLegalPrice && props.throwHasPendingLegalPrice()) {
        setIsAwaitingLegalPrice(true);
        setInvalidTermPopup(true);
        awaitedMaximumAllowedTerm = await props.throwAwaitPendingLegalPrice();
        termLimitForPopupRef.current = awaitedMaximumAllowedTerm;
        setIsAwaitingLegalPrice(false);
        setInvalidTermPopup(false);
      }

      if (!checkedState && functionController == 'TermChange' &&
        agrTerm !== shareData?.agreementPricing?.agreementTerm) {
        // UI selects the correct increase or decrease SLA limits from the displayed baseline term.
        const isTermDecrease = Number(agrTerm) <= Number(effectiveTermOverrideLimitBase);
        const configLimitKey = isTermDecrease ? 'min' : 'max';

        // Get both min and max limits for full range calculation
        const values = Object.values(configTermDataObj);
        const minValues = values
          .filter((value: any) => value && typeof value === 'object' && 'min' in value)
          .map((value: any) => Number(value.min))
          .filter((v: number) => !isNaN(v));
        const maxValues = values
          .filter((value: any) => value && typeof value === 'object' && 'max' in value)
          .map((value: any) => Number(value.max))
          .filter((v: number) => !isNaN(v));

        const numericValues = values
          .filter((value: any) => value && typeof value === 'object' && configLimitKey in value)
          .map((value: any) => Number(value[configLimitKey]))
          .filter((v: number) => !isNaN(v));

        if (numericValues.length === 0) {
          // No valid config for this direction — allow the change through
          Number(agrTerm) < 1
            ? setinvalidTerm(true)
            : props.setreceiveAgreementTerm(agrTerm);
          return;
        }

        const maxPercentageEdit = Math.max(...numericValues);
        const maxMinPercentageEdit = minValues.length > 0 ? Math.max(...minValues) : maxPercentageEdit;
        const maxMaxPercentageEdit = maxValues.length > 0 ? Math.max(...maxValues) : maxPercentageEdit;
        // UI calculates the override percentage from the backend-adjusted term currently shown to the user.
        const maxAllowablbeLimit = (Number(effectiveTermOverrideLimitBase) * Number(maxPercentageEdit)) / 100
        const percentCalculationInBlur = Math.abs(
          Math.ceil(((Number(effectiveTermOverrideLimitBase) - Number(agrTerm)) * 100) / Number(effectiveTermOverrideLimitBase))
        );
        console.log("percentCalculationInBlurCheck", percentCalculationInBlur)

        let minRole = '';
        let enteredIf = false;
        let output;

        const Roles = [
          'FSC-CAR',
          'CAR',
          'RPMT',
          'FSC-AM',
          'AM',
          'FSC-LAM',
          'LAM',
          'FSC-SMT',
          'SMT',
          'FSC-SM',
          'SM',
          'FSC-SSM',
          'SSM',
          'CAM',
          'FSC-DMT',
          'DMT',
          'FSC-DM',
          'DM',
          'FSC-RDT',
          'RDT',
          'FSC-RD',
          'RD'
        ];
        // RP-668: The upper bound for term-override validation is now the Maximum Allowed Term
        // derived from legal/price (falls back silently to initialAgreementTerm the existing
        // package-item/price term when legal/price failed or was unusable). Uses
        // awaitedMaximumAllowedTerm (resolved above, after waiting for any pending background
        // legal/price call) rather than re-reading shareData directly, since shareData may not
        // have re-rendered yet with the just-resolved value.
        const maximumAllowedTermLimit =
          awaitedMaximumAllowedTerm !== undefined && awaitedMaximumAllowedTerm !== null
            ? awaitedMaximumAllowedTerm
            : initialAgreementTerm;
        termLimitForPopupRef.current = maximumAllowedTermLimit;
        if ((Number(agrTerm) < Number(10) || Number(agrTerm) > Number(maximumAllowedTermLimit)) ) {  
          setInvalidTermPopup(true)
        }
        else if (Number(maxPercentageEdit) < Number(percentCalculationInBlur)) {
          if (CurrentRole == 'RD' || CurrentRole == 'FSC-RD' || CurrentRole == 'RDT' || CurrentRole == 'FSC-RDT') {
            setopenTermAlertModal(true)
            // RD-level users see the valid term range calculated from the backend-adjusted displayed term.
            const maxMinLimit = (Number(effectiveTermOverrideLimitBase) * Number(maxMinPercentageEdit)) / 100;
            const maxMaxLimit = (Number(effectiveTermOverrideLimitBase) * Number(maxMaxPercentageEdit)) / 100;
            const lowerBound = Number(Math.ceil(Number(effectiveTermOverrideLimitBase) - maxMinLimit));
            const upperBound = Number(Math.floor(Number(effectiveTermOverrideLimitBase) + maxMaxLimit));
            setslaErrorMessage(`${t("Term is invalid. Allowable Term Values are")} ${lowerBound} ${t("to")} ${upperBound}`)
            return

          }
          else {
            setopenTermAlertModal(true)
            // Other coworkers see the SLA override range calculated from the backend-adjusted displayed term.
            const maxMinLimit = (Number(effectiveTermOverrideLimitBase) * Number(maxMinPercentageEdit)) / 100;
            const maxMaxLimit = (Number(effectiveTermOverrideLimitBase) * Number(maxMaxPercentageEdit)) / 100;
            const lowerBound = Number(Math.ceil(Number(effectiveTermOverrideLimitBase) - maxMinLimit));
            const upperBound = Number(Math.floor(Number(effectiveTermOverrideLimitBase) + maxMaxLimit));
            setslaErrorMessage(`${t("Override is invalid. SLA user can override from")} ${lowerBound} ${t("to")} ${upperBound}`)
            return
          }
        }
        else {
          for (const item in configTermDataObj) {
            const roleLimitValue = termValidationConfigData[item]?.[configLimitKey];
            if (roleLimitValue == undefined) continue;
            if (
              roleLimitValue == Number(percentCalculationInBlur).toFixed(2) &&
              Number(percentCalculationInBlur) !== 0
            ) {
              minRole = item;
              output = item;
              setSLAMinRole(item);
              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            } else if (roleLimitValue > Number(percentCalculationInBlur)) {
              minRole = item;
              output = item
              setSLAMinRole(item);

              if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
                setneedSLA({ ...needSLA, needSLAController: true });
                enteredIf = true;
              }
              break;
            }
          }

          console.log('logged roles', CurrentRole);

          // Build grouped data for BOTH min and max to get current role's limits
          const groupedDataMin: { [key: string]: string[] } = {};
          const groupedDataMax: { [key: string]: string[] } = {};

          for (const [key, value] of Object.entries(termValidationConfigData)) {
            const minLimitValue = (value as any)?.['min'];
            const maxLimitValue = (value as any)?.['max'];

            if (minLimitValue != undefined) {
              const stringValue = String(minLimitValue);
              if (!groupedDataMin[stringValue]) {
                groupedDataMin[stringValue] = [key];
              } else {
                groupedDataMin[stringValue].push(key);
              }
            }

            if (maxLimitValue != undefined) {
              const stringValue = String(maxLimitValue);
              if (!groupedDataMax[stringValue]) {
                groupedDataMax[stringValue] = [key];
              } else {
                groupedDataMax[stringValue].push(key);
              }
            }
          }

          console.log("groupedDataMin", groupedDataMin)
          console.log("groupedDataMax", groupedDataMax)

          let currentRoleMinValue: number = 0;
          let currentRoleMaxValue: number = 0;

          for (const key of Object.keys(groupedDataMin)) {
            if (groupedDataMin[key].includes(CurrentRole)) {
              currentRoleMinValue = parseInt(key) || 0;
              break;
            }
          }

          for (const key of Object.keys(groupedDataMax)) {
            if (groupedDataMax[key].includes(CurrentRole)) {
              currentRoleMaxValue = parseInt(key) || 0;
              break;
            }
          }

          console.log("currentRoleMinValue", currentRoleMinValue)
          console.log("currentRoleMaxValue", currentRoleMaxValue)

          // Safety check: if role values are not found, use 0 to avoid NaN
          if (currentRoleMinValue === 0 && currentRoleMaxValue === 0) {
            console.warn("Role limits not found for:", CurrentRole);
          }

          // UI shows each coworker's approval boundary using the backend-adjusted displayed term.
          let allowedMinTerm = Number(effectiveTermOverrideLimitBase) - (Number(effectiveTermOverrideLimitBase) * (currentRoleMinValue / 100));
          let allowedMaxTerm = Number(effectiveTermOverrideLimitBase) + (Number(effectiveTermOverrideLimitBase) * (currentRoleMaxValue / 100));

          console.log("allowedMinTerm", allowedMinTerm)
          console.log("allowedMaxTerm", allowedMaxTerm)
          console.log("effectiveTermOverrideLimitBase", effectiveTermOverrideLimitBase)

          setthresHoldExceptionMessage(
            isTermDecrease
              ? `${t("Coworker can only change term upto")} ${Math.ceil(
                Number(allowedMinTerm)
              )} ${t("second level approval is required for this change.")}`
              : `${t("Coworker can only change term upto")} ${Math.ceil(
                Number(allowedMaxTerm)
              )} ${t("second level approval is required for this change.")}`
          );
          if (enteredIf === false) {
            console.log('entered if pricing call', enteredIf);
            props.setreceiveAgreementTerm(agrTerm);
          }
        }
      }
      else {
        Number(agrTerm) < 1
          ? setinvalidTerm(true)
          : props.setreceiveAgreementTerm(agrTerm)
      }
    }
  };

  const RateTermChange = (stateController: any, e?: any) => {
    if (
      e.key == 'Enter' &&
      stateController == 'RateChange' &&
      agrRate !== shareData.agreementPricing.agreementRate
    ) {
      // {
      (document.getElementById('AgrRate') as HTMLInputElement).blur();
      // parseInt(agrRate) < 1
      //   ? setinvalidTerm(true)
      //   : props.setreceiveAgreementRate(agrRate);
      // }
    } else if (
      e.key == 'Enter' &&
      stateController == 'TermChange' &&
      agrTerm !== shareData.agreementPricing.agreementTerm
    ) {
      // {
      (document.getElementById('AgrTerm') as HTMLInputElement).blur();
      //   parseInt(agrTerm) < 1
      //     ? setinvalidTerm(true)
      //     : props.setreceiveAgreementTerm(agrTerm);
      // }
      // if (checkedState) {
      //   setcontrolCurrencyInput(true);
      // }
    } else if (stateController == 'CompetitorChange') {
      props.setCompetitorValue(e.target.checked);
      setisCompCheck(e.target.checked);
      console.log('e.target.checked check in log', e.target.checked);

      if (e.target.checked === false) {
        // setcorrectProof(false);
        // setcompetitorSelect('');
        // props.setCompetitorDropValue('');
        console.log('false clicked');

        setDefault();
      }

      {
        checkedState ? setcheckedState(false) : setcheckedState(true);
        checkedState ? setControlCompetitor(true) : setControlCompetitor(false);
      }
    }
  };

  const temp = (itemID: any) => {
    props.triggeroneDelete(itemID);
  };

  // const closeZeroValidate = () => {
  //   setDefault();
  //   setenableZeroValidate(false);
  // };

  const handleClick = () => {
    setproof('');
  };

  const onUploadFileChange = ({ target }) => {
    console.log('target value check in proof', target.value);

    if (target.value == '') {
      setproof('');
      return;
    }

    // if (proof !== '') {
    //   setproof(proof);
    // } else {
    setproof(target.value);
    // }
    // let finalData: any = '';
    // if (target.value) {
    //   //setproof(target.value);
    //   finalData = truncString(
    //     target.value.replace('C:\\fakepath\\', ''),
    //     10,
    //     '...'
    //   );
    //   console.log('finalData', finalData);
    //   setcompeFileName({ ...compeFileName, fileNameCompetitor: finalData });
    // } else {
    //   //setproof(proof);
    //   setcompeFileName({ ...compeFileName, fileNameCompetitor: proofFileName });
    // }

    //setproof(target.value);
    const finalData = truncString(
      target.value.replace('C:\\fakepath\\', ''),
      10,
      '...'
    );
    setfullCompeFileName(target.value.replace('C:\\fakepath\\', ''));
    console.log('finalData', finalData);
    setcompeFileName({ ...compeFileName, fileNameCompetitor: finalData });

    let proofController: any = 1;
    if (target.files < 1 || !target.validity.valid) {
      return;
    }
    if (target.value) {
      fileToBase64(target.files[0], (err, result) => {
        if (result) {
          setFile(result);
          setFileName(target.files[0]);
        }
        const fileSize = Math.round(target.files[0].size / 1024);
        if (fileSize >= 1024) {
          proofController = 0;
        }

        const fileType = target.files[0].type;
        const extensionType = target.files[0].type.split('/').pop();
        console.log('required file', target.files[0].name);
        if (
          (extensionType === 'pdf' ||
            extensionType === 'img' ||
            extensionType === 'png' ||
            extensionType === 'jpeg' ||
            extensionType === 'jpg' ||
            extensionType === 'svg') &&
          proofController == 1
        ) {
          setwrongProof(false);
          setcorrectProof(true);
          setbigFile(false);
          setproofFileName(finalData);
        } else if (proofController == 0) {
          setwrongProof(false);
          setcorrectProof(false);
          setbigFile(true);
        } else {
          setwrongProof(true);
          setcorrectProof(false);
          setbigFile(false);
        }
        const proofData = {
          fileType: fileType,
          base64Data: result.slice(result.indexOf(',') + 1),
          extensionType: extensionType,
        };
        setcompetitorProofData(proofData);
        setcompetitorData(proofData);
      });
    }
  };

  const fileToBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(null, reader.result);
    };
    reader.onerror = function (error) {
      cb(error, null);
    };
  };

  const invalidTermDiv = (displayData: any) => {
    return (
      <div
        id="decisionengine"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="decisionengine"
        aria-hidden="true"
      >
        {/* <div className="modal-dialog">
  
              <div className="modal-content"> */}

        <Grid item md={12} className={classes.textCenter}>
          <Typography className={`${classes.semiBold} ${classes.font16}`}>
            {displayData}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            size="large"
            variant="contained"
            color="primary"
            onClick={() => closeInvalidTermAndRate()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const SLACancel = () => {
    setSLAController({ ...SLAController, TwoFactorCancelClick: false });
    setSecondFactorEnabled(false);
    setagrRate(shareData.agreementPricing.agreementRate);
    setagrTerm(shareData?.agreementPricing?.agreementTerm);
  };
  const SLACompleted = (value: any) => {
    setSLAController({ ...SLAController, TwoFactorCompleted: value });
    setSecondFactorEnabled(false);
  };

  const acceptSLA = () => {
    setneedSLA({ ...needSLA, needSLAController: false });
    setSecondFactorEnabled(true);
  };

  const SLAModal = (displayData: any) => {
    return (
      <div id="decisionengine">
        <Grid item md={12} className={classes.textCenter}>
          <Typography className={`${classes.semiBold} ${classes.font16}`}>
            {displayData}
          </Typography>
          <Typography className={`${classes.semiBold} ${classes.font16}`}>
            {t("Do you want to proceed ?")}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.me3}
            size="large"
            variant="outlined"
            color="secondary"
            onClick={() => {
              setneedSLA({ ...needSLA, needSLAController: false });
              setagrRate(shareData.agreementPricing.agreementRate);
              setagrTerm(isExchangeAgreement ? shareData?.agreementPricing?.exchangeAgreementTerm : shareData?.agreementPricing?.agreementTerm)
            }}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            size="large"
            variant="contained"
            color="primary"
            onClick={() => acceptSLA()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  // useEffect(() => {
  //   if (SLAController.TwoFactorCompleted) {
  //     parseInt(agrRate) < 1
  //       ? setinvalidTerm(true)
  //       : props.setreceiveAgreementRate(agrRate);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [SLAController.TwoFactorCompleted]);

  useEffect(() => {
    console.log(
      'SLAController.TwoFactorCompleted',
      SLAController.TwoFactorCompleted
    );

    if (SLAController.TwoFactorCompleted) {
      //debugger
      // && percentCalculation <= 50
      // parseInt(agrRate) < 1
      //   ? setinvalidTerm(true)
      //   :

      if (Number(agrRate) !== Number(shareData.agreementPricing.agreementRate)) {
        props.setreceiveAgreementRate(agrRate, SLAMinRole);

      }
      else if (Number(agrTerm) !== Number(shareData?.agreementPricing?.agreementTerm)) {
        props.setreceiveAgreementTerm(agrTerm, SLAMinRole);
      }

    }
    // else if (SLAController.TwoFactorCompleted && roleFromSLA == '008') {
    //   // parseInt(agrRate) < 1
    //   //   ? setinvalidTerm(true)
    //   //   : props.setreceiveAgreementRate(agrRate);
    //   console.log('expected point reached');

    //   props.setreceiveAgreementRate(agrRate);
    // }
    // else if (SLAController.TwoFactorCompleted && percentCalculation > 50) {
    //   console.log('reached the alert log');
    //   const allowedRate = Math.round(initialAgreementRate * 0.5);
    //   const minAmount = initialAgreementRate - allowedRate;
    //   setslaOverrideInvalid(
    //     `Override is invalid. SLA user can override from $${parseFloat(
    //       minAmount.toString()
    //     ).toFixed(2)} to $${initialAgreementRate}`
    //   );
    //   setopenRateAlertModal(true);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SLAController.TwoFactorCompleted]);


  const acceptRateAlert = () => {
    setopenRateAlertModal(false);
    setagrRate(shareData.agreementPricing.agreementRate);
  };

  const openRateAlert = () => {
    return (
      <div>
        <Grid className={classes.textCenter}>
          {slaErrorMessage.includes('Allowable') ? null : <Erroricon className={classes.racErrorIcon} />
          }
          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {slaErrorMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptRateAlert}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const acceptTermAlertUser = () => {
    setopenTermAlertModal(false);
    setagrTerm(shareData.agreementPricing.agreementTerm);
  };

  const openRateAlertUser = () => {
    return (
      <div>
        <Grid className={classes.textCenter}>
          {slaErrorMessage.includes('Allowable') ? null : <Erroricon className={classes.racErrorIcon} />
          }
          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {slaErrorMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptTermAlertUser}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };


  const acceptTermAlert = () => {
    setInvalidTermPopup(false);
    termLimitForPopupRef.current = undefined;
    setagrTerm(shareData?.agreementPricing?.agreementTerm);
  }
  const openTermAlert = () => {
    // RP-668: Show spinner inside popup while waiting for background legal/price to resolve
    if (isAwaitingLegalPrice) {
      return (
        <div>
          <Grid className={classes.textCenter} style={{ padding: '20px' }}>
            <CircularProgress size={30} />
          </Grid>
        </div>
      );
    }
    // UI shows the same term used by the validation check.
    const maximumAllowedTermForMessage =
      termLimitForPopupRef.current ?? maximumAllowedTerm ?? initialAgreementTerm;
    return (
      <div>
        <Grid className={classes.textCenter}>

          <Typography className={classes.racErrorFunction} style={{ fontSize: '16px' }}>
            {t("Term is invalid. Allowable terms are 10 -")} {maximumAllowedTermForMessage}
          </Typography>
        </Grid>
        <Grid className={classes.textCenter} style={{ marginTop: '20px' }}>
          <RACButton
            autoFocus
            variant="contained"
            color="primary"
            className={classes.spacerME2}
            onClick={acceptTermAlert}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };


  const provideSLAData = (value: any) => {
    console.log('received provideSLA', value);
    const roleCode = value.substr(value.length - 3);
    console.log('received provideSLA after trim', roleCode);

    setroleFromSLA(roleCode);
  };

  return (
    <Grid item md={3}>
      {/* The approval popup receives the displayed baseline term when the user overrides the term. */}
      {SecondFactorEnabled === true ? (
        <SecondFactor
          // setTwoFactorCancelClick={setTwoFactorCancelClick}
          setTwoFactorCancelClick={SLACancel}
          // setTwoFactorCompleted={setTwoFactorCompleted}
          setTwoFactorCompleted={SLACompleted}
          setRoleFromSLAModule={provideSLAData}
          moduleName={ModuleName}
          currentRole={CurrentRole}
          minRole={SLAMinRole}
          throwCurrentPage="addedItem"
          agrRate={Number(agrRate) != Number(initialAgreementRate) ? initialAgreementRate : null}
          agrTerm={Number(agrTerm) != Number(effectiveTermOverrideLimitBase) ? effectiveTermOverrideLimitBase : null}
        />
      ) : null}
      <Typography className={`${classes.title} ${classes.mt2}`} variant="h6">
        {t("Added Items")}
      </Typography>
      <Card className={classes.card}>
        <CardContent className={classes.p1}>
          <Card
            className={`${classes.racBlue} ${classes.card} ${classes.p3} ${classes.pb0}`}
          >
            <BlueCard
              //throwPackage={throwPackageValue}
              triggerTemp={temp}
              throwStyle={props.throwStyle}
            />
          </Card>

          <div className={`${classes.mt3}`}>
            <div className={classes.row}>
              {isExchangeAgreement ?
                <>
                  <Typography className={classes.title} variant="h6">
                    {t("Exchange Agreement")}
                  </Typography>
                  <Grid md={12} className={`${classes.mb3} ${classes.flexCenter}`}>
                    <Typography variant="caption" className={`${classes.formLabel} ${classes.w90}`}>
                      {t("Exchange Agreement Reduction")}
                    </Typography>
                    <Grid
                      className={`${addedItemClassName.inputGroup} ${classes.floatRight}`}
                    >
                      <Typography className={classes.floatRight}>
                        (${shareData?.agreementPricing?.rentPaid?.toFixed(2)})
                      </Typography>
                    </Grid>
                  </Grid>
                </>
                : null}
              <Typography className={classes.title} variant="h6">
                {t("Agreement Total")}
              </Typography>
              <WhiteCard throwStyle={props.throwStyle} />
              <Grid md={12} className={`${classes.mb3} ${classes.flexCenter}`}>
                {/* {props.module == "Package" ? (
                  <Typography variant="caption" className={classes.formLabel}>
                    Pkg Rate
                  </Typography>
                ) : ( */}
                <Typography variant="caption" className={classes.formLabel}>
                  {t("Agreement Rate")}
                </Typography>
                {/* )} */}

                <Grid
                  className={`${addedItemClassName.inputGroup} ${classes.w50} ${classes.floatRight}`}
                >
                  <Typography className={addedItemClassName.inputGroupText}>
                    $
                  </Typography>

                  <CurrencyInput
                    id="AgrRate"
                    name="AgrRate"
                    value={agrRate}
                    disabled={
                      ((coworkerCheck == 'Y'
                        ? (competitorSelect == '0') || (competitorSelect == '')
                          ? true
                          : false
                        : false) || isExchangeAgreement)
                      || (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride != '1' && shareData.itemPricing[0].packageName == 'ADD-ON PACKAGE')
                    }
                    className={isExchangeAgreement || (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride != '1' && shareData.itemPricing[0].packageName == 'ADD-ON PACKAGE') ? `${classes.formControl} ${addedItemClassName.currencyAlign} ${classes.semiBold} ${addedItemClassName.disabledColourAgrRate}` : `${classes.formControl} ${addedItemClassName.currencyAlign} ${classes.semiBold}`}
                    decimalScale={2}
                    decimalsLimit={2}
                    onValueChange={(e) => agrRatechange(e)}
                    onBlur={() => blurFuction('RateChange')}
                    onKeyDown={(e) => RateTermChange('RateChange', e)}
                  // disabled={controlCurrencyInput}
                  />
                </Grid>
              </Grid>
              <Grid md={12} className={`${classes.mb3} ${classes.flexCenter}`}>
                {/* {props.module == 'Package' ? (
                  <Typography variant="caption" className={classes.formLabel}>
                    Pkg Term
                  </Typography>
                ) : ( */}
                <Typography variant="caption" className={classes.formLabel}>
                  {t("Agreement Term")}
                </Typography>
                {/* )} */}
                <Grid
                  className={`${addedItemClassName.inputGroup} ${classes.w50} ${classes.floatRight}`}
                >
                  <RACTextbox
                    id="AgrTerm"
                    type="number"
                    name="itemNo"
                    disabled={
                      (coworkerCheck == 'Y' ? true : false) ||
                      isExchangeAgreement ||
                      (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride != '1' && shareData.itemPricing[0].packageName == 'ADD-ON PACKAGE')
                    }
                    isCurrency={false}
                    digitFormat="normal"
                    value={agrTerm}
                    OnChange={(e) => agrTermchange(e.target.value)}
                    Onblur={() => blurFuction('TermChange')}
                    //OnKeydown={(e) => checkAgrTermChange(e)}
                    OnKeydown={(e) => RateTermChange('TermChange', e)}
                  //onKeydown={(e) => checkAgrTermChange(e.target.value)}
                  />
                </Grid>
              </Grid>
              {isInReinstateMode == '0' ? (
                <>
                  <Grid md={12}>
                    <Typography
                      variant="subtitle2"
                      className={`${classes.racpadLink} ${classes.textRight} ${classes.textDecoration}`}
                      data-testid="SetToDefault"
                      style={{ cursor: 'pointer' }}
                      onClick={setDefault}
                    >
                      {t("Set to Default")}
                    </Typography>
                  </Grid>

                  {featureFlagDetails?.CompetitorMatch == 1 ?
                    <Grid md={12} className={classes.mb2}>
                      <RACCheckBox
                        size="small"
                        onChange={(e) => RateTermChange('CompetitorChange', e)}
                        disabled={isExchangeAgreement}
                        checked={checkedState}
                      />
                      <Typography variant="caption" className={classes.formLabel} style={{ cursor: 'context-menu' }}>
                        {t("Competitor Match")}
                      </Typography>
                    </Grid> : null}

                  {featureFlagDetails.MXStoreIdentifier !== "1" && (
                    <Grid md={12} style={{ marginTop: '4px' }}>
                      <Typography variant="caption" className={classes.formLabel}>
                        {t("Competitor")}
                      </Typography>
                      <Grid
                        className={`${addedItemClassName.inputGroup} ${classes.w50} ${classes.floatRight} ${classes.mb2}`}
                      >
                        <RACSelect
                          // loading={conditionLoader}
                          options={competitorArrayFunction()}
                          defaultValue={competitorSelect !== '' ? competitorSelect : '0'}
                          isDisabled={controlCompetitor}
                          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                            e.target.value === '0'
                              ? setcompetitorSelect('')
                              : setcompetitorSelect(e.target.value);
                            props.setCompetitorDropValue(e.target.value);
                            setselectedCompetitor(e.target.value);
                          }}
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              ) : null}

              {featureFlagDetails.MXStoreIdentifier !== "1" && (
                agreementCreateStatus !== undefined &&
                  agreementCreateStatus.agreementCreatedStatus === false ? (
                  <Grid md={12}>
                    <Typography
                      variant="caption"
                      className={`${classes.formLabel} ${classes.w50}`}
                    >
                      {t("Competitor Proof")}
                    </Typography>
                    <Grid
                      className={`${classes.w50} ${classes.floatRight} ${classes.ps2} ${classes.mb3}`}
                    >
                      <Grid className={addedItemClassName.uploadBtnWrapper}>
                        <button
                          type="button"
                          className={addedItemClassName.buttonUploading}
                          title=""
                        >
                          <input
                            type="file"
                            title=""
                            name="filetobase64"
                            value={proof}
                            disabled={controlCompetitor}
                            onChange={(e) => onUploadFileChange(e)}
                            onClick={handleClick}
                            accept="application/pdf, image/png, image/jpeg, image/svg, image/jpg"
                          />
                          <Uploading
                            className={`${classes.me2} ${classes.mb1}`}
                          />
                          {t("Upload")}
                        </button>
                        {correctProof ? (
                          <RACChip
                            icon={false}
                            className={`${classes.textWhite} ${classes.mt2} ${classes.semiBold} ${addedItemClassName.chipBackground}`}
                            label={compeFileName.fileNameCompetitor}
                            color="primary"
                            onDelete={() => {
                              setcorrectProof(false);
                              setcompetitorProofData(undefined);
                            }}
                            title={fullCompeFileName}
                          />
                        ) : null}
                        {wrongProof ? (
                          <label
                            className={`${classes.textRed} ${classes.mt2} ${classes.semiBold}`}
                          >
                            {t("Upload Only .pdf, .jpeg, .jpg, .png, .svg Files")}
                          </label>
                        ) : null}
                        {bigFile ? (
                          <label
                            className={`${classes.textRed} ${classes.mt2} ${classes.semiBold}`}
                          >
                            {t("Upload file less than 1Mb")}
                          </label>
                        ) : null}
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null
              )}

            </div>
          </div>
          <Card
            className={`${classes.card} ${classes.racTotalBlue} ${classes.p3}`}
          >
            <Grid
              md={12}
              className={`${addedItemClassName.agrAddedTotal} ${classes.mb2}`}
            >
              {isInReinstateMode == '1' && isSacDaysCompleted == '1' || featureFlagDetails.MXStoreIdentifier == '1' ? (
                <>
                  <Typography
                    variant="caption"
                    className={`${classes.textBlue} ${classes.font14} ${classes.semiBold}`}
                  >
                    {t("EPO Amount")}
                  </Typography>

                  {epoAmount !== undefined ? (
                    <Typography
                      variant="caption"
                      className={`${classes.textBlue} ${classes.font18} ${classes.bold}`}
                    >
                      ${epoAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </Typography>
                  ) : (
                    <Typography
                      variant="caption"
                      className={`${classes.textBlue} ${classes.font18} ${classes.bold}`}
                    >
                      $ 0.00
                    </Typography>
                  )}
                </>
              ) : (
                <>
                  <Typography
                    variant="caption"
                    className={`${classes.textBlue} ${classes.font14} ${classes.semiBold}`}
                  >
                    {t("Same As Cash Total")}
                  </Typography>

                  <Typography
                    variant="caption"
                    className={`${classes.textBlue} ${classes.font18} ${classes.bold}`}
                  >
                    ${cashPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  </Typography>
                </>
              )}
            </Grid>
            <Grid
              md={12}
              className={`${addedItemClassName.agrAddedTotal} ${classes.mb2}`}
            >
              <Typography
                variant="caption"
                className={`${classes.textBlue} ${classes.font14} ${classes.semiBold}`}
              >
                {t("Agreement Total")}
              </Typography>
              {/* )} */}

              <Typography
                variant="caption"
                className={`${classes.textBlue} ${classes.font18} ${classes.bold}`}
              >
                ${agrTotal.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Typography>
            </Grid>
          </Card>
        </CardContent>
      </Card>

      <RACModalCard
        isOpen={invalidTerm}
        maxWidth="xs"
        borderRadius={'26px !important'}

      // children={invalidTermDiv()}
      >
        {invalidTermDiv(t("Invalid term. Term should be greater than 0"))}
      </RACModalCard>

      <RACModalCard
        isOpen={enableZeroValidate}
        maxWidth="xs"
        borderRadius={'25px !important'}

      //children={enableZeroValidatediv()}
      >
        {invalidTermDiv(t('Invalid rate. Rate should be greater than $0.00'))}
      </RACModalCard>

      <RACModalCard
        isOpen={needSLA.needSLAController}
        maxWidth="xs"
        borderRadius={'25px !important'}
      //children={enableZeroValidatediv()}
      >
        {SLAModal(thresHoldExceptionMessage)}
      </RACModalCard>
      <RACModalCard
        isOpen={openRateAlertModal}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openRateAlert()}
      ></RACModalCard>

      {/* Invalid Term Popup */}
      <RACModalCard
        isOpen={invalidTermPopup}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openTermAlert()}
      ></RACModalCard>
      {/* Invalid Term user popup */}
      <RACModalCard
        isOpen={openTermAlertModal}
        maxWidth={'sm'}
        borderRadius="25px !important"
        //eslint-disable-next-line react/no-children-prop
        children={openRateAlertUser()}
      ></RACModalCard>
    </Grid>
  );
};

export default AddedItem;
